import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NavigationService } from 'src/app/services/navigation.service';
import { ProductService } from 'src/app/services/product.service';
import { Location } from '@angular/common';
import { ManufacturerService } from 'src/app/services/manufacturer.service';
import { GenericValidator } from 'src/app/views/layout/validators/generic-validator';
import { AlertService } from 'src/app/services/alert.service';



@Component({
  selector: 'app-manufacturerclarifypopup',
  templateUrl: './manufacturerclarifypopup.component.html',
  styleUrls: ['./manufacturerclarifypopup.component.scss']
})
export class ManufacturerclarifypopupComponent implements OnInit {
  showNotes: boolean = true;
  form: FormGroup;
  id: any;
  dropdownSettings: any = {};
  clarificationList: any[] = [];
  clarificationListCopy: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    private productService: ProductService,
    private _location: Location,
    private manufactureService : ManufacturerService,
    private genericValidator: GenericValidator,
    private alertService: AlertService,




    public dialogRef: MatDialogRef<ManufacturerclarifypopupComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToEdit: any,

    public addServiceDialog: MatDialog,
    private navigationService: NavigationService,
  ) { this.id = this.dataRecievedToEdit.id }

  ngOnInit(): void {
    this.initializeValidators();
    this.get();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'key',
      textField: 'value',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true
    };
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      clarificationType: ['',Validators.required],
      remarks:['',Validators.required]
    })
  }

  next() {
    if (this.form.valid) {
      const clarificationListtype = [];
      const selectedclarificationtype = this.form.get('clarificationType').value;
      if (selectedclarificationtype && selectedclarificationtype.length > 0) {
        selectedclarificationtype.forEach(element => {
          clarificationListtype.push(element.key);
        });
      }
      let data = {
        id:0,
        dbtManufacturerId:this.id,
        remarks:this.form.value.remarks,
        manufacturerEditType:JSON.stringify(clarificationListtype)
      }
      this.manufactureService.clarificationsave(data).subscribe(res =>{
        if (res && res.isSuccess) {
          this.alertService.success('Saved Successfully');
          // setInterval(() => {
          //   this.router.navigate(['/auth/login']);
          // }, 3000);
    this.dialogRef.close();
    this._location.back();

        } else {
          this.alertService.error(res.htmlFormattedFailures);
        }
      })

      
    }else
    {
      this.genericValidator.validateFormControl(this.form);

    }
    // this.dialogRef.close();

  }

  cancel(isProceed) {
    this.dialogRef.close(isProceed);

  }


  get() {
    this.clarificationList = [];
    this.clarificationListCopy = [];
    this.manufactureService.geteditmanufacturedropdown(true).subscribe(res => {
      if (res) {
        this.clarificationList = res;
        this.clarificationListCopy= res;
      }
    })
    this.clarificationListCopy = this.clarificationList;
  }

  // goToAction(item: number) {
  //   if (this.form.valid) {
  //     this.productService.productApprove(this.id, item, true).subscribe(result => {
  //       if (result) {
  //         this._location.back();
  //       }
  //     });
  //   }
  // }

}
